// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import 'vue2-toast/lib/toast.css'
import * as helpers from '@/helpers'
import moment from 'moment'

import VueResource from 'vue-resource'
import BootstrapVue from 'bootstrap-vue'
import Datepicker from 'vuejs-datepicker'
import Toast from 'vue2-toast'

Vue.mixin({
  data: () => {
    return {
      ...helpers
    }
  },
  methods: {
    currency: function (price) {
      return parseFloat(price).toFixed(2) + ' ' + store.getters.outlet.currency
    },
    monthName: function (month) {
      return moment(month, 'MM').format('MMMM')
    },
    moment: function (date, format = 'YYYY-MM-DD') {
      return moment(date).format(format)
    }
  },
  filters: {
    price: function (price) {
      if (price == 0) { // eslint-disable-line
        return 0
      }
      return parseFloat(price).toFixed(2)
    },
    currency: function (price, currency) {
      if (!currency) {
        currency = store.getters.outlet.region.currency
      }
      return parseFloat(price).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') + ' ' + currency
    },
    monthName: function (month) {
      return moment(month, 'MM').format('MMMM')
    },
    moment: function (date, format = 'YYYY-MM-DD') {
      return moment(date).format(format)
    }
  }
})

Vue.use(VueResource)
Vue.use(BootstrapVue)
Vue.use(Toast)

Vue.component('Datepicker', Datepicker)

Vue.http.headers.common['Access-Control-Allow-Origin'] = '*'

Vue.http.interceptors.push((request, next) => {
  next((response) => {
    // switch (response.status) {
    //   case 401:
    //   case 429:
    //   case 403: {
    //     router.replace({path: '/not-authorized'})
    //     break
    //   }
    //   default:
    //   // nothing
    // }
  })
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js